import { z } from 'zod'

export const paymentHistorySearchSchema = z.object({
  page: z.coerce.number().int().min(1).catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(10),
  sortBy: z.enum(['period']).catch('period'),
  direction: z.enum(['asc', 'desc']).catch('desc'),
})

export type PaymentHistorySearch = z.infer<typeof paymentHistorySearchSchema>

export const defaultPaymentHistorySearch: PaymentHistorySearch = {
  page: 1,
  pageSize: 10,
  sortBy: 'period',
  direction: 'desc',
}
